import type { ResultOf } from '@graphql-typed-document-node/core'
import { atom, useAtomValue, useSetAtom } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { graphql } from '~/lib/graphql'
import { useInitAtom } from '~/lib/jotai'
import { env$ } from '~/stores/env'
import { initSelectedArea } from '../area'

export const GetPopularityRestaurants = graphql(/* GraphQL */ `
  query GetPopularityRestaurants(
    $input: SearchRestaurantsInput!
  ) {
    searchRestaurants(input: $input, first: 10) {
      edges {
        node {
          ...RestaurantRecommendCard
        }
      }
    }
  }
`)

export type GetPopularityRestaurantsType = ResultOf<typeof GetPopularityRestaurants>

const selectedPoplarRestaurantsArea$ = atom<string | undefined>(undefined)
selectedPoplarRestaurantsArea$.debugLabel = 'selectedPoplarRestaurantsArea$'

export function useHydrateSelectedPoplarRestaurantsArea(code?: string) {
  useInitAtom(selectedPoplarRestaurantsArea$, initSelectedArea(code))
}

export function useSelectedArea() {
  return useAtomValue(selectedPoplarRestaurantsArea$)
}

export function useSetSelectedArea() {
  return useSetAtom(selectedPoplarRestaurantsArea$)
}

const popularRestaurants$ = atomWithQuery<GetPopularityRestaurantsType>((get) => ({
  queryKey: ['popularRestaurants', get(selectedPoplarRestaurantsArea$)],
  queryFn: async function () {
    const area = get(selectedPoplarRestaurantsArea$)
    const env = get(env$)
    const largeAreaCode = area?.slice(0, 2) ?? ''
    const mediumAreaCode = area?.slice(2, 5) ?? ''
    const url = new URL(`${env.RESTAURANT_IKYU_ORIGIN}/api/v2/popularity-restaurants`)
    url.searchParams.set('largeAreaCode', largeAreaCode)
    url.searchParams.set('mediumAreaCode', mediumAreaCode)
    const result = await fetch(url.toString())
    return result.json()
  },
}))

export function usePopularRestaurants() {
  return useAtomValue(popularRestaurants$)
}
